// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1EP_D","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1U0hR"};